import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'How to Implement Single Sign-On | Canny';
const Description =
  'Single sign-on lets you authenticate your users with their existing user accounts in your Canny widget.';
const Image = 'https://canny.io/images/canny-social.png';

export default class WidgetDocsSSOHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://developers.canny.io/install/widget/sso' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
